import { composeClasses } from '@wiggot/utils/src/strings'
import { IlustrationVariants } from '../../../utils'
import { MdClose } from 'react-icons/md'
import Ilustration from '../../../assets/svg/search-engine-background.svg'
import Asterisk from '../../../assets/svg/asterisk.svg'

interface Props {
  variant: string
  onCloseFunc: () => void
  className?: string
  subtitleClassName?: string
}

export const FormIlustration = ({ className, variant, onCloseFunc, subtitleClassName }: Props) => {
  const { title, text, color } = IlustrationVariants[variant]
  const baseClassName = `md:max-w-[18.75rem] md:p-8 md:min-h-[515px] md:rounded-l-xl md:rounded-tr-none min-h-[150px] relative w-full flex flex-col md:justify-end justify-start p-6 overflow-hidden rounded-t-xl ${className}`
  return (
    <div className={composeClasses(color, baseClassName)}>
      <img src={Ilustration} className="absolute md:left-[104px] md:top-[192px] top-[16px] left-[65%] z-0 md:h-[155px] h-[120px]"/>
      <img src={Asterisk} className="md:flex hidden absolute right-[100px] top-[-214px] spin-animation z-0 min-w-[400px] "/>
      <span className="md:text-2xl text-white text-normal font-semibold">
        {title}
      </span>
      <span className={composeClasses("text-white md:text-base text-xs font-semibold my-2", subtitleClassName)}>
        {text}
      </span>
      <button
        className="md:hidden flex items-center justify-center bg-transparent absolute top-[1.5rem] right-[1.5rem]" 
        onClick={onCloseFunc}
      >
        <MdClose className="w-6 h-6 fill-white"/>
      </button>
    </div>
  )
}
